module.exports = __webpack_public_path__ + "media/application/images/icons/innovations/farmer-eaed3c172bed2b8895e925a6bcf0787a.svg";